/**
 * Login-Seite - Leitet sofort zum Logto OIDC Flow weiter
 */

import { useEffect } from 'react'
import { useLogto } from '@/auth/oidc'
import { AlertCircle, Loader2 } from 'lucide-react'

const POST_LOGIN_REDIRECT_KEY = 'netzfabriks_post_login_redirect'

export function Login() {
  const { signIn, isAuthenticated, isLoading, error } = useLogto()

  useEffect(() => {
    if (error) {
      return
    }

    if (isLoading) {
      return
    }

    if (isAuthenticated) {
      window.location.replace('/')
      return
    }

    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, '/')
    void signIn({
      redirectUri: window.location.origin + '/callback',
      postRedirectUri: window.location.origin + '/',
    })
  }, [error, isAuthenticated, isLoading, signIn])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 dark:bg-gray-900">
        <div className="max-w-md text-center space-y-4">
          <AlertCircle className="h-12 w-12 mx-auto text-destructive" />
          <h1 className="text-xl font-semibold text-foreground">Anmeldung konnte nicht gestartet werden</h1>
          <p className="text-sm text-muted-foreground break-words">{error.message}</p>
          <button
            type="button"
            onClick={() => { window.location.reload() }}
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Erneut versuchen
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  )
}

export default Login
